import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';
import VotingRoutes from './VotingRoutes';
const VotingLayout = props => {
	useEffect(() => {}, []);

	return (
		<Router fallback={<span />}>
			<Switch>
				<Route component={VotingRoutes} />
			</Switch>
			<ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
		</Router>
	);
};

export default VotingLayout;
